module.exports = __webpack_public_path__ + "static/img/cbjt.a456bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/cbjt.png
// module id = cFGK
// module chunks = 13